module.exports = __webpack_public_path__ + "static/media/scoreHeatmap.0cbadce9.jpg";